import React, { useState, useEffect, useContext } from "react";

import lbl from "../../../data/Labels.json";
import db from "../../../services/query";

import PrintHeader from "../common/PrintHeader";
import PrintBodyTitle from "../common/PrintBodyTitle";
import PrintTable from "../common/PrintTable";

import { HalfYearContext } from "../../../contexts/halfYearContext";

const RevenueBudgets = () => {
  let printHeadTexts = ["معاونیت امور مالی و اداری", "مدیریت مالی"];
  const [tableTitles, setTableTitles] = useState({ mainTitle: "بودجه ها" });

  const { halfYear } = useContext(HalfYearContext);

  const columns = [
    { path: "id", label: "شماره" },
    { path: "name", label: "نام" },
    { path: "revenue_type", label: "حوزه درآمد" },
    { path: "budget", label: "بودجه" },
    { path: "paid", label: "پرداخت شده" },
    { path: "balance", label: "باقیمانده" },
  ];

  const [data, setData] = useState([]);

  useEffect(() => {
    requestData();

    return () => setData([]);
  }, []);

  const requestData = async (p = new Object()) => {
    try {
      let query = `revenues/budget/accounts?halfYearId=${halfYear}`;

      await db.getAll(query).then(({ data }) => {
        setData(data);
      });
    } catch ({ response }) {
      setData(response);
    }
  };

  return (
    <main className="main-print-wrapper">
      <PrintHeader
        title={tableTitles.mainTitle}
        printHeadTexts={printHeadTexts}
      />
      <PrintBodyTitle title={[]} />
      <PrintTable columns={columns} data={data} />
    </main>
  );
};

export default RevenueBudgets;
